import blue from '@material-ui/core/colors/blue';


export const palette = {
    type: 'light',
    secondary: blue,
};
